module.exports = __webpack_public_path__ + "static/media/cereza_background.d978df38.jpeg";